import { render, staticRenderFns } from "./file-element.vue?vue&type=template&id=3151069c&scoped=true&"
import script from "./file-element.vue?vue&type=script&lang=js&"
export * from "./file-element.vue?vue&type=script&lang=js&"
import style0 from "./file-element.vue?vue&type=style&index=0&id=3151069c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3151069c",
  null
  
)

export default component.exports